<template>
  <div>
    <div class="section-header pageHeader" ref="headerWrapper">
      <h1>{{title}}</h1>
      <div class="section-header-breadcrumb">
        <slot name="buttons"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: ["wfDtl", "page", "reqdtl", "formData", "type"],
  data() {
    return {
      isMounted: false
    };
  },
  computed: {
    breadcrumbs() {
      return this.$route.meta.breadcrumbs ? this.$route.meta.breadcrumbs : [];
    },
    title() {
      return this.$route.meta.title;
    }
  },
  mounted() {
    if ($("body").hasClass("sidebar-mini")) {
      $(".pageHeader").css("left", "65px");
    } else if ($("body").hasClass("sidebar-gone")) {
      $(".pageHeader").css("left", "0px");
    } else {
      $(".pageHeader").css("left", "250px");
    }
    if ($("body").hasClass("sidebar-gone")) {
      return;
    }
    $("[data-toggle='sidebar']").click(() => {
      this.$nextTick(() => {
        if ($(window).outerWidth() <= 1024) {
          return;
        }
        if ($("body").hasClass("sidebar-mini")) {
          $(".pageHeader").animate({ left: "65px" }, 250);
        } else {
          $(".pageHeader").animate({ left: "250px" }, 250);
        }
      });
    });
    //console.log( this.breadcrumbs.length);
  },
  watch: {
    // $route() {
    //   this.breadcrumbs = this.$route.meta.breadcrumbs;
    // }
  }
};
</script>
